import React, { Component } from 'react';
import Button from '../../CustomButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment } from '@fortawesome/free-solid-svg-icons';
import './index.css';
import ShareButton from '../../ShareButton';

class ImgLeft extends Component {
  constructor(props) {
    super(props);
    this.state = { shareButtonVertical:true }
    this.viewArticleClickHandler = this.viewArticleClickHandler.bind(this);
    this.shareButtonVertical = this.shareButtonVertical.bind(this);
  }

    
  topLayer_JC(){
    const { lang } = this.props;
    if (window.matchMedia('(min-width: 1450px)').matches) {
      if(lang==='en'){ return 'center' }
      else {return '' }
    } else if(window.matchMedia('(max-width: 520px)').matches){
      if(lang==='fa'){return 'center'}
      else {return '' }
    } else {
      if(lang==='fa'){return 'flex-end'}
      else {return '' }
    }
  }


  btnIcon_fD(){
    const { lang } = this.props;
    if (window.matchMedia('(max-width: 520px)').matches) {
      return 'column'
    } else {
      if(lang==='fa'){return'row'}
      else { return'row-reverse'}
    }
  }

  viewArticleClickHandler(){
    this.props.onViewArticleClick(this.props.item);
  }

  shareButtonVertical(){
    if (window.matchMedia('(max-width: 520px)').matches) {
      return false;
    } else { return true }
  }


  render() {
    const { lang } = this.props;
    const { bgColor, title, headerImg, headerIcon, description, bgIconClass, likes, comments, date } = this.props.item;
    const _bgColor = bgColor ? bgColor : {leftBgClass:'bg-red', rightBgClass:'bg-white'};
    const _title = title ? title : {fa:'بدون عنوان', en:'no title'};
    const _description = description ? description : {fa:'بدون خلاصه', en:'no description'};
    const _shareButtonVertical = this.shareButtonVertical()
    return (
      <div className='bloge-content-img-left-container'>
        <div className='bloge-content-img-left-wrapper'>
          <div className={'bloge-content-img-left-right-layer ' + _bgColor.rightBgClass}></div>
          <div className={'bloge-content-img-left-left-layer ' + _bgColor.leftBgClass}></div>
          <div className='bloge-content-img-left-top-layer'>
            <div className='bloge-content-img-left-top-layer-description' style={{justifyContent: this.topLayer_JC()}}>
              <div className='bloge-content-img-left-top-ld-w' style={{textAlign:lang==='fa' ? 'right' : 'left'}}>
                <div style={{direction:lang==='fa' ? 'rtl' : 'ltr'}} className='bloge-content-img-left-top-ld-dw'>
                  <div>
                    <div className='bloge-content-img-left-top-ld-hi'>
                      <h1 style={{marginLeft: lang==='en' ? '10px':''}}>{lang==='fa' ? _title.fa : _title.en}</h1>
                      <div style={{marginLeft: lang==='fa' ? '10px':''}} className={bgIconClass? bgIconClass :'bg-red'}>
                        {headerIcon ? headerIcon : lang==="fa" ? '' : ''}
                      </div>
                    </div>
                    <div className='bloge-content-img-left-top-ld-hi'>
                      <p>{lang==='fa' ? (<span>{_description.fa}</span>) :(<span>{_description.en}</span>)}</p>
                      <div style={{marginLeft: lang==='fa' ? '10px':'',visibility:'hidden'}} className={bgIconClass? bgIconClass :'bg-red'}>
                        {headerIcon ? headerIcon : lang==="fa" ? '' : ''}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{flexDirection: this.btnIcon_fD()}} className='bloge-content-img-left-btn-icon-sec'>
                  <div>
                    <Button onClick={this.viewArticleClickHandler} className='bloge-content-img-left-tl-button-a'> 
                      {lang === 'fa' ? 'ادامه مطلب' : 'View Article'} 
                    </Button>
                  </div>
                  <div className='bloge-content-img-left-tl-icon'>
                    <div>
                      <FontAwesomeIcon icon={faHeart} color="rgba(100, 100, 100, 0.2)" />
                      <span>{likes ? likes + ' Like': 0 + ' Like'}</span>
                    </div>
                    <div>
                      <FontAwesomeIcon icon={faComment} color="rgba(100, 100, 100, 0.2)" />
                      <span>{comments ? comments : 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='bloge-content-img-left-top-layer-img-wrapper'>
              {headerImg ? headerImg : lang==="fa" ? 'بدون عکس' : 'no image'}
              <div className="bloge-content-img-left-top-layer-img-shadow"></div>
            </div>
            <div className='bloge-content-img-left-release-date-wrapper'>
              {date ? date : 'no release date'}
            </div>
            <div className='bloge-content-img-left-share-button-wrapper'> 
              <ShareButton style={{color:'#000'}} lang={lang} vertical={_shareButtonVertical} showLeft={true}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default ImgLeft;
